<template>
  <div class="hp-manager-page-list">
    <filter-form :filter='filter' @handleSubmit="handleSubmit" ref="filter">
    </filter-form>
    <standard-table ref="datas" size="default" :bordered="true" :columns="columns" :indentSize=15 :dataSource="datas" :pagination="pagination" :loading="loading"  :scroll="scroll"  @tableChange="tableChange">
      <template slot="selfactions" slot-scope="rowKey">
        <span>
          <a :disabled="!(permissionChecker('OrderAudit.BranchAudit') || permissionChecker('OrderAudit.HeadAudit'))" @click="handleEdit(2,rowKey.data)">审核</a>
        </span>
      </template>
    </standard-table>

    <hp-manager-modal :width="modalWidth" :title="'审核订单'" v-model="addVisible">
      <hp-manager-page-ordermaster-audit slot="slot" @submit-success="refreshCurrent" @cancel="addVisible = false" :params="params"></hp-manager-page-ordermaster-audit>
    </hp-manager-modal>
  </div>
</template>

<script>
import { api } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import hpManagerPageOrdermasterAudit from "./Audit";
import config from "@/config";
import { setTimeout } from "timers";

export default {
  mixins: [account, dateFormat, moneyFormat],
  components: {
    hpManagerPageOrdermasterAudit
  },
  data() {
    return {
      filter: [
        {
          type: "input",
          key: "orderNo",
          name: "订单号"
        },
        {
          type: "select",
          key: "organizationId",
          name: "销售组织",
          options: []
        },
        {
          type: "input",
          key: "dealerName",
          name: "经销商"
        },
        {
          type: "select",
          key: "orderType",
          name: "订单类型",
          options: [
            { name: "标准订单", val: 0 },
            { name: "定制订单", val: 1 },
            { name: "促销订单", val: 2 }
          ]
        },
        {
          type: "dateFilter",
          key: "effective",
          name: "下单时间"
        },
        {
          type: "cascader",
          key: "groupId",
          name: "客户分组",
          options: []
        },
        {
          type: "cascader",
          key: "departmentId",
          name: "部门",
          options: []
        },
        {
          type: "input",
          key: "departmentName",
          name: "部门名"
        }
      ],
      scroll: { x: 1900 },
      columns: [
        {
          title: "操作",
          dataIndex: "action",
          width: 60,
          scopedSlots: { customRender: "action" }
        },
        {
          title: "订单类型",
          width: 100,
          dataIndex: "orderType",
          sorter: true,
          customRender: (text, row, index) => {
            return row.orderTypeStr;
          }
        },
        {
          title: "订单号",
          width: 120,
          dataIndex: "orderNo",
          sorter: true
        },
        {
          title: "状态",
          width: 100,
          dataIndex: "status",
          customRender: (text, row, index) => {
            return row.statusStr;
          }
        },
        {
          title: "销售组织",
          width: 180,
          dataIndex: "organizationName"
        },
        {
          title: "部门",
          width: 100,
          dataIndex: "departmentName"
        },
        {
          title: "经销商",
          width: 160,
          dataIndex: "dealerName"
        },
        {
          title: "订单金额",
          width: 120,
          dataIndex: "totalOrderAmount"
        },
        {
          title: "发货方式",
          width: 120,
          dataIndex: "deliveryMethod",
          customRender: (text, row, index) => {
            return row.deliveryMethodStr;
          }
        },
        {
          title: "下单时间",
          width: 180,
          dataIndex: "creationTime",
          customRender: (text, row, index) => {
            return this.formatDate(row.creationTime, "YYYY-MM-DD HH:mm:ss");
          }
        },
        {
          title: "创建人",
          width: 120,
          dataIndex: "creatorUserName"
        },
        {
          title: "订单来源",
          width: 90,
          dataIndex: "orderSource",
          customRender: (text, row, index) => {
            return row.orderSourceStr;
          }
        },
        {
          title: "修改时间",
          width: 180,
          dataIndex: "lastModificationTime",
          customRender: (text, row, index) => {
            return this.formatDate(
              row.lastModificationTime,
              "YYYY-MM-DD HH:mm:ss"
            );
          }
        }
      ],
      datas: [],
      filterdata: JSON.parse(JSON.stringify(config.pageFilter)),
      pagination: JSON.parse(JSON.stringify(config.page)),
      params: {},
      qxParams: {},
      addVisible: false,
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      modalWidth: "1300px",
      childWidth: "0px",
      childHeight: "0px",
      explain: "",
      visible: false,
      permission: [],
      title: "",
      allGroups: [],
      allDepartments: []
    };
  },
  async mounted() {
    this.GetOrganizationOptions();
    this.getAllGroups();
    this.getAllDepartment();
    this.permission = this.getPermission("Order");
    this.getDatas(this.filterdata);
  },
  methods: {
    async GetOrganizationOptions() {
      let org = await api.GetOrganizationSelect();
      if (org) {
        let organizationOptions = [];
        org.forEach(a => {
          organizationOptions.push({
            name: a.text,
            val: a.value
          });
        });
        this.filter.filter(
          a => a.key == "organizationId"
        )[0].options = organizationOptions;
      }
    },
    async getAllGroups() {
      let groupList = await api.GetAllDealerGroups();
      if (groupList) {
        this.allGroups = groupList;
      }
      this.filter.filter(a => a.key == "groupId")[0].options = groupList;
    },
    async getAllDepartment() {
      let departmentList = await api.GetAllDepartmentData();
      if (departmentList) {
        this.allDepartments = departmentList;
      }
      this.filter.filter(
        a => a.key == "departmentId"
      )[0].options = departmentList;
    },
    handleSubmit(p) {
      this.pagination.current = 0;
      this.filterdata.orderNo = p.values.orderNo;
      this.filterdata.organizationId = p.values.organizationId;
      this.filterdata.orderType = p.values.orderType;
      this.filterdata.status = p.values.status;
      this.filterdata.departmentName = p.values.departmentName;
      //this.filterdata.dealerGroup=p.values.dealerGroup;
      console.log(p.values.groupId);
      this.filterdata.departmentId =
        p.values.departmentId != null && p.values.departmentId.length > 1
          ? p.values.departmentId[1] != null
            ? p.values.departmentId[1]
            : null
          : null;
      if (p.values.groupId != null && p.values.groupId.length >= 1) {
        if (p.values.groupId[2] != null) {
          this.filterdata.groupId = p.values.groupId[2];
        } else if (p.values.groupId[1] != null) {
          this.filterdata.groupId = p.values.groupId[1];
        } else {
          this.filterdata.groupId =
            p.values.groupId[0] != null ? p.values.groupId[0] : null;
        }
      } else {
        this.filterdata.groupId = null;
      }
      this.filterdata.dealerName = p.values.dealerName;
      this.filterdata.startTime =
        p.values.effective[0] != null ? p.values.effective[0].valueOf() : null;
      this.filterdata.endTime =
        p.values.effective[1] != null ? p.values.effective[1].valueOf() : null;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    //弹出编辑 详情 新增 模态框
    handleEdit(type, record) {
      this.isabl = false;
      this.params = Object.assign({ isShow: this.isabl }, record);
      this.addVisible = true;
    },
    refreshCurrent() {
      this.pagination.current = 0;
      this.addVisible = !this.addVisible;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    tableChange(table) {
      if (table.page) {
        this.pagination.current = table.page.current;
        this.pagination.pageSize = table.page.pageSize;
        this.maxResultCount = table.page.pageSize;
        this.filterdata.skipCount =
          table.page.current == 1
            ? 0
            : (table.page.current - 1) * this.maxResultCount;
        this.filterdata.maxResultCount = table.page.pageSize;
      }
      if (table.filters.code && table.filters.code.length > 0) {
        console.log(table.filters);
      }
      if (table.sorter.field) {
        this.filterdata.sorting =
          table.sorter.field +
          " " +
          (table.sorter.order == "ascend" ? "asc" : "desc");
      }
      this.getDatas(this.filterdata);
    },

    async getDatas(options) {
      this.loading = true;
      let data = await api.GetOrderMasterAuditList(options);
      this.datas = data.items;
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/router/Orders/OrderMaster/AuditList.vue